import React from 'react';
import { 
  Row,
  Col,
  Progress 
} from 'reactstrap';

import './ExperienceBar.css';

const ExperienceBar = ({ levelData }) => {
  const {
    currentLevel,
    experienceInLevel,
    experienceToNextLevel,
    progressRatio
  } = levelData;

  const progressPercent = (experienceInLevel / experienceToNextLevel) * 100;
  const isInside = progressPercent >= 15;

  return (
    <Row style={{ padding: '10px 0px', maxWidth: '400px' }}>
      <Col xs={2} style={{ padding: '0px 0px' }}>
        <div style={{ fontSize: '14px' }}>{`Lv${currentLevel}`}</div>
      </Col>
      <Col xs={10} style={{ display: 'flex', padding: '0px 5px', alignItems: "center" }}>
        <div style={{ position: 'relative', width: '100%' }}>
          <Progress value={progressRatio * 100} style={{ height: '10px', borderRadius: '10px' }} color="info" />
          <div style={{
            position: 'absolute',
            top: 0,
            //left: `${(experienceInLevel / experienceToNextLevel) * 50}%`,
            left: isInside ? `${progressPercent/2}%` : `${50+progressPercent/2}%`,
            transform: isInside ? 'translateX(-50%)' : 'translateX(-50%)',
            color: isInside ? 'white' : 'black',
            fontSize: '9px',
            lineHeight: '100%', // aligns with bar height
            height: '100%',
            display: 'flex',
            alignItems: 'center'
          }}>
            {`${Math.floor((experienceInLevel / experienceToNextLevel) * 100)}% ${`(${experienceInLevel}/${experienceToNextLevel})`}`}
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default ExperienceBar;